import { useState, useEffect } from 'react'
import { decksLoader, deckIdeasLoader } from '../apiCalls'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from 'react-bootstrap/Button'
import ShuffleIdeaComp from '../components/shuffleIdeaComp'

const Shuffle = (props) => {
    const user = props.mods.currentUser

    const [decks, setDecks] = useState([])
    const [deckIdeas, setDeckIdeas] = useState({})
    const [deckSelected, setDeckSelected] = useState(false)
    const [shuffled, setShuffled] = useState(false)
    const [shuffledIdea, setShuffledIDea] = useState(false)

    async function getDecks() {
        const myDecks = await decksLoader()
        setDecks(myDecks)
    }

    useEffect(() => {
        getDecks()
    }, [])

    function buildDeckList() {
        let deckList = decks.map((value, idx) => {
            function selectDeck() { 
                getDeck(value._id)
                setDeckSelected(true)
                }   
            return (
                <Dropdown.Item key={idx} onClick={selectDeck}>{value.name}</Dropdown.Item>
            )
        })
        return deckList
    }

    async function getDeck(id) {
        let myDeck = await deckIdeasLoader(id)
        setDeckIdeas(myDeck.ideas)
    }

    function handleShuffle() {
        const length = deckIdeas.length
        const idea = deckIdeas[Math.floor(Math.random() * length)]
        setShuffled(true)
        setShuffledIDea(idea)
    }

    function ideaRender() {
        if (deckSelected && deckIdeas.length && shuffled > 0) {
            return (
                <Row className="deckIdeaRow">
                    <Col>
                        <ShuffleIdeaComp mods ={{shuffledIdea, user}} />
                    </Col>
                </Row>
            )
        } else if (deckSelected && deckIdeas.length < 1) {
            return (
                <Row className="justify-content-center">
            <p className="text-light">No ideas in this deck. Add some from the Ideas tab!</p></Row>
            )
        } else if (deckSelected && deckIdeas.length > 0) {
                return (
                <Row className="justify-content-center">
                    <p className="text-light">Click Shuffle!</p>
                </Row>
                )
            } else {
            return (
            <Row className="justify-content-center">
                <p className="text-light">Select a deck and click Shuffle!</p>
            </Row> )
        }
    }


    return (
        <div className="deckContainer">
            <Row>
                <Col>
                    <Dropdown>
                    <Dropdown.Toggle variant="dark" id="dropdown-basic" className="defaultButton deckButton">Decks
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {(decks.length > 0) ? buildDeckList() : <Dropdown.Item>No Decks Available. Make a new one in the Decks tab!</Dropdown.Item>}
                    </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col>
                    {(deckSelected && deckIdeas.length > 0 ) ? <Button onClick={handleShuffle} className="btn-dark defaultButton shuffleButton">Shuffle!</Button> : <Button className="btn-dark defaultButton shuffleButton" disabled>Shuffle!</Button>}
                </Col>
            </Row>
            {ideaRender()}
        </div>
    )
}

export default Shuffle